import React from "react";

function UserAnalyticsIcon({ stroke = "#344054" }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 20.75V18.5278C0.75 17.349 1.21825 16.2186 2.05175 15.3851C2.88524 14.5516 4.0157 14.0833 5.19444 14.0833H9.63889C10.8176 14.0833 11.9481 14.5516 12.7816 15.3851C13.6151 16.2186 14.0833 17.349 14.0833 18.5278V20.75M15.1944 0.894445C16.1505 1.13922 16.9978 1.69522 17.6029 2.47479C18.208 3.25436 18.5365 4.21314 18.5365 5.2C18.5365 6.18686 18.208 7.14564 17.6029 7.92521C16.9978 8.70478 16.1505 9.26078 15.1944 9.50556M20.75 20.75V18.5278C20.7444 17.5468 20.4144 16.5953 19.8114 15.8216C19.2085 15.0478 18.3665 14.4952 17.4167 14.25M2.97222 5.19444C2.97222 6.37318 3.44047 7.50365 4.27397 8.33714C5.10746 9.17064 6.23793 9.63889 7.41667 9.63889C8.59541 9.63889 9.72587 9.17064 10.5594 8.33714C11.3929 7.50365 11.8611 6.37318 11.8611 5.19444C11.8611 4.0157 11.3929 2.88524 10.5594 2.05175C9.72587 1.21825 8.59541 0.75 7.41667 0.75C6.23793 0.75 5.10746 1.21825 4.27397 2.05175C3.44047 2.88524 2.97222 4.0157 2.97222 5.19444Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UserAnalyticsIcon;
